export default __webpack_public_path__ + "static/icon-2-4-8c4ec2db982d7f05fbe490a405617201.png";